import React, { Component } from 'react';
import PostEditor from '../new-post/new-post.component';
import './edit-post.style.css';
import UserContext from '../../utils/userContext';


const EditPost = (props) => {
    return(
        <PostEditor action="edit" contentId={`${props.match.params.contentId}`} history={props.history}/>
    )
}





export {EditPost};
